<template>
  <template v-for="(item, index) in items" :key="item.id">
    <DisplayPublic :advertisement="item" class="mt-2" />
    <div
      v-if="$screen.showMobileAds && index === 3"
      class="a-container mt-3 mb-3">
      <AdsMobilePage />
    </div>
  </template>
 
</template>

<script setup>
import DisplayPublic from './DisplayPublic.vue'
import AdsMobilePage from '~/components/GoogleAdvertisements/AdsMobilePage.vue'

defineProps({
  items: { type: Array, default: () => [] }
})
</script>
